<template>
  <div>
    <div class="file-box">
      <div class="upload-shell">
        <input ref="input" type="file" accept=".xlsx,.xls" class="native-file-input" @change="onChange" />
        <button type="button" class="upload-cta" @click="openFileDialog">Seleccionar archivo</button>
        <div class="upload-hint" :class="file ? 'has-file' : ''">{{ file ? file.name : 'Sube un archivo Excel (.xls o .xlsx)' }}</div>
        <CButton v-if="file" size="sm" color="danger" class="trash-btn" @click="clearFile">
          <CIcon name="cil-trash" />
        </CButton>
      </div>

      <small class="text-muted d-block mt-2">Formatos permitidos: .xls y .xlsx</small>
      <small class="text-muted d-block">Tamano maximo sugerido: {{ maxSizeMb }} MB</small>

      <div v-if="error" class="text-danger mt-2" style="font-size: 12px;">{{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImportFileInput',
  props: {
    file: {
      type: File,
      default: null
    },
    error: {
      type: String,
      default: ''
    },
    maxSizeMb: {
      type: Number,
      default: 10
    }
  },
  methods: {
    openFileDialog() {
      if (this.$refs.input) {
        this.$refs.input.click()
      }
    },
    onChange(event) {
      const selected = event.target.files && event.target.files[0] ? event.target.files[0] : null
      this.$emit('file-change', selected)
    },
    clearFile() {
      if (this.$refs.input) {
        this.$refs.input.value = ''
      }
      this.$emit('clear-file')
    }
  }
}
</script>

<style scoped>
.file-box {
  border: 1px solid #d7ddd6;
  border-radius: 8px;
  padding: 12px;
  background: #fbfcfb;
}

.upload-shell {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #c9d4cb;
  background: #fff;
  border-radius: 6px;
  min-height: 44px;
  overflow: hidden;
}

.native-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.upload-cta {
  background: #668269;
  color: #fff;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  border: 0;
  outline: none;
}

.upload-hint {
  flex: 1;
  padding: 0 12px;
  color: #7d8893;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-hint.has-file {
  color: #32414f;
  font-weight: 500;
}

.trash-btn {
  margin-right: 8px;
}
</style>
